var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "column": "",
      "justify-center": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "overflow": "hidden"
    }
  }, [_c('form-body', _vm._b({
    attrs: {
      "mode": "sign"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'form-body', {
    index: _vm.index
  }, false))], 1), _c('v-divider'), _c('form-noti', _vm._b({
    model: {
      value: _vm.disabled,
      callback: function ($$v) {
        _vm.disabled = $$v;
      },
      expression: "disabled"
    }
  }, 'form-noti', {
    form: _vm.form
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }